import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Header } from 'semantic-ui-react';

import ListRow from './ListRow';

class List extends Component {
  render() {
    const { customerDealerGroupList, onSelectDealerGroup } = this.props;
    const listRow = ListRow(onSelectDealerGroup);

    const headerRow = (
      <Table.Row>
        <Table.HeaderCell>Group ID</Table.HeaderCell>
        <Table.HeaderCell>Group Name</Table.HeaderCell>
        <Table.HeaderCell>Description</Table.HeaderCell>
        <Table.HeaderCell>Created At</Table.HeaderCell>
        <Table.HeaderCell>Updated At</Table.HeaderCell>
        <Table.HeaderCell />
      </Table.Row>
    );

    return (
      <div>
        <Header>Dealer Groups</Header>
        <div>
          <Table
            celled
            selectable
            padded
            renderBodyRow={listRow}
            tableData={customerDealerGroupList}
            headerRow={headerRow}
            size='small'
            compact='very'
            style={{ fontSize: '90%' }}
            striped
            className='pre-wrap-table'
          />
        </div>
      </div>
    );
  }
}

List.propTypes = {
  customerDealerGroupList: PropTypes.array,
  onSelectDealerGroup: PropTypes.func,
};

export default List;
